import { Enums } from "../../../thor.enums";
import { OnlineItemsFilterParams } from "../../../typings/online";

export class OnlineContainersEditFilterController {
    public static $inject: string[] = ["$mdMedia", "$mdSidenav"];

    // Binded
    public filterParams: OnlineItemsFilterParams;
    public reset: Function;
    public queryOptions;
    public itemsStatesCount;

    public isContainerPublished: boolean;
    public isContainerScheduled: boolean;
    public showHiddenFilter;
    public showSuppressedFilter;

    constructor(public $mdMedia: ng.material.IMedia, private $mdSidenav: ng.material.ISidenavService) {}

    public $onInit() {
        this.checkStates();
    }

    public cancel() {
        this.filterParams = {};
        this.reset();
    }

    public toggle() {
        this.$mdSidenav("filternav").toggle();
    }

    public toggleExclusiveFilters(param: keyof OnlineItemsFilterParams) {
        const exclusiveFilters = ["hidden", "suppressed"];

        if (this.filterParams[param]) {
            exclusiveFilters.forEach(k => k !== param && (this.filterParams[k] = false));
        }
    }

    /**
     * Check Online sale's publication status: scheduled, published or edited
     * Check suppress and hidden filters display
     * @returns {undefined}
     */
    private checkStates() {
        const { isScheduled, saleStarted, status } = this.filterParams.containerStatus || {};
        const saleEdited = status === Enums.SaleStatus.Edited;
        const salePublished = status === Enums.SaleStatus.Published || saleEdited;

        this.isContainerPublished = !isScheduled && salePublished;
        this.isContainerScheduled = !this.filterParams.isPast && (isScheduled || saleEdited);

        this.showHiddenFilter = salePublished && (saleStarted || this.filterParams.isPast);
        this.showSuppressedFilter = !this.filterParams.isPast;
    }
}
